module.exports = __webpack_public_path__ + "img/Photo-ID.ffd9bc0b.jpg";